import { useState } from "react";
import { useSelector } from "react-redux";
import { Pagination } from "@mui/material";
import { keepPreviousData,useQuery } from "@tanstack/react-query";
import { Loader2 } from "lucide-react";

import { SearchInput } from "components/ui";

import { fetchMedications } from "./fetch-medications";
import styles from "./SelectMedicationsTable.module.css";
import { SelectMedicationsTableItem } from "./SelectMedicationsTableItem";

const rowsPerPage = 20;

export const SelectMedicationsTable = ({ selectDrug }) => {

  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");

  const tenant =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  const {
    data: medications,
    isLoading,
    isFetching: isLoadingMore,
  } = useQuery({
    queryKey: ["medications", search, tenant, page],
    queryFn: () => fetchMedications({ search, page, tenant }),
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
    debounceTime: 300,
    placeholderData: keepPreviousData,
  });

  const handleChange = (_event, value) => {
    setPage(value);
  };

  const renderTableContent = () => {
    if (isLoading || isLoadingMore) {
      return (
        <div className={styles.emptyState}>
          <Loader2 className={styles.loadingSpinner} size={24} />
          <p className={styles.emptyStateTitle}>Loading data...</p>
          <p className={styles.emptyStateText}>
            Please wait while we fetch the medications.
          </p>
        </div>
      );
    }

    if (medications.data.length === 0) {
      return (
        <div className={styles.emptyState}>
          <p className={styles.emptyStateTitle}>No items found</p>
          <p className={styles.emptyStateText}>
            {search
              ? "Try adjusting your search or filters to find what you're looking for."
              : "There are no items to display at this time."}
          </p>
        </div>
      );
    }

    return (
      <ul className={styles.tableItems}>
        {medications.data.map((item) => (
          <SelectMedicationsTableItem
            key={item.id}
            item={item}
            selectDrug={selectDrug}
          />
        ))}
      </ul>
    );
  };

  return (
    <>
      <div className={styles.tableWarpper}>
        <div className={styles.table}>
          <div className={styles.tableTopBarWrapper}>
            <SearchInput
              value={search}
              onChange={(value) => {
                setSearch(value);
                setPage(1);
              }}
              placeholder="Search"
            />

          </div>
          <div className={styles.tableHeader}>
            <p id="results-table-trade-name">Trade name</p>
            <p id="results-table-generic-name">Generic name</p>
            <p id="results-table-manufacturer">Manufacturer</p>
            <p id="results-table-strength">Strength</p>
            <p id="results-table-pack">Pack</p>
            <div />
          </div>
          {renderTableContent()}
          {medications?.totalRecords && medications.data?.length > 0 && (
            <div className={styles.paginationWrapper}>
              <p className={styles.resultsInfo}>
                {medications?.totalRecords &&
                  medications.data?.length > 0 &&
                  `${(medications.page - 1) * medications.rowsPerPage + 1}-
              ${
                (medications.page - 1) * medications.rowsPerPage +
                medications.data?.length
              } 
              of ${medications.totalRecords} medications`}
              </p>
              <Pagination
                count={Math.ceil(medications?.totalRecords / rowsPerPage)}
                onChange={handleChange}
                page={page}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};
